// extracted by mini-css-extract-plugin
module.exports = {"beta":"beta-module--beta--mwkgF"};